import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import { Layout } from 'antd';
import { adminActionCreators } from '../../../Actions/AdminActions';
import AdminSiderMenu from '../Components/AdminSiderMenu';
import AdminHeader from '../Components/AdminHeader';
import AddUser from '../Components/AddUser';
import Enums from '../../../Constants/Enums';
import { adminPageTitles } from '../../../Constants/CommonConstants';

const { Content } = Layout;

export class AdminAddUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      entity: '',
      api: null
    };
    this.prevTitle = '';
  }

  componentDidMount() {
    this.props.getUserLookUpApi();
    if(this.props.match?.params?.userId > 0) {
      this.props.getSelectedItemDetail(Number(this.props.match.params.userId), this.props.activeEntity)
    }
    const pageType = this.props.match?.params?.userId < 1
    ? 'addUser'
    : 'editUser';
    this.prevTitle = document.title;
    document.title = adminPageTitles[pageType]
  }

  componentWillUnmount() {
    document.title = this.prevTitle;
  }


  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  render() {
    const {
      history, userLookup, isFetching, isDetailFetching, userProfileData,
    } = this.props;
    const { path } = this.props.match;
    const { collapsed } = this.state;
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <AdminSiderMenu path={path} onCollapse={this.onCollapse} history={history} collapsed={collapsed} />
        <Layout>
          <Layout.Header style={{ background: '#fff', minHeight: 52, padding: 0 }}>
            <AdminHeader collapsed={this.state.collapsed} toggle={this.toggle} />
          </Layout.Header>
          <Content>
            {
              !isDetailFetching && !isFetching &&
              <AddUser
                userProfileData={userProfileData}
                errors={this.props.userErrors}
                userLookup={userLookup}
                resettingPassword={this.props.resettingPassword}
                sendingConfirmation={this.props.sendingConfirmation}
                isNewUser = {this.props.match?.params?.userId < 1}
              />
            }
            </Content>
        </Layout>
      </Layout>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { path } = ownProps.match;
  const entityArray = path.split('/');
  return {
    activeEntity: entityArray[Enums.NUMERIC_VALUE.TWO],
    userProfileData: state.admin.selectedItemData || {},
    userErrors: state.admin.errors || {},
    userLookup: state.admin.userLookup || {},
    isDetailFetching: state.admin.isDetailFetching,
    isFetching: state.admin.isFetching,
    resettingPassword: state.admin.resettingPassword,
    sendingConfirmation: state.admin.sendingConfirmation,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...adminActionCreators }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminAddUser));
